import React from 'react';
import Anime from 'react-anime';
import pipeImg from '../assets/elements/pipe/Middle.png';
import pipeCapImg from '../assets/elements/pipe/Opening-top.png';
import './SplitPipe.scss';
export default ({ isActive }) => {
  const message = `Such scientific rigor took center stage in the regulation of drugs in 1962. That year, the US Congress, under the guidance of doctors and scientists, began to require the use of evidence from randomized controlled clinical trials for drug approval by the FDA. The approach is now a worldwide standard for bringing effective and safe medicines to patients who need them.`;
  const moveBall1 = {
    top: [
      { value: '-15vh', duration: 0},
      { value: '15vh', duration: 1000, easing: 'linear'},
      { value: '150vh', duration: 1500, easing: 'easeInSine', delay: 3000}
    ],
    left: [
      { value: '25%', duration: 0},
      { value: '75%', duration: 1000, easing: 'linear', delay: 1000}
    ]
  }
  const moveBall2 = {
    top: [
      { value: '-15vh', duration: 0},
      { value: '15vh', duration: 1000, easing: 'linear'},
      { value: '150vh', duration: 1500, easing: 'easeInSine', delay: 3000}
    ],
    left: [
      { value: '25%', duration: 0},
      { value: '-27%', duration: 1000, easing: 'linear', delay: 1000}
    ]
  }
  return (
    <div className="split-pipes">
      <div className="pipes">
        <div className="silo">
          <img src={pipeImg} className="pipe" />
          <img src={pipeCapImg} className="cap"/>
          {isActive && (
            <Anime {...moveBall1} className="ball">
              <div></div>
            </Anime>
          )}
        </div>
        <div className="silo">
          <img src={pipeImg} className="pipe" />
          <img src={pipeCapImg} className="cap"/>

          {isActive && (
          <Anime {...moveBall2} className="ball">
            <div></div>
          </Anime>
          )}
        </div>
      </div>

      <div className="text-container movedown">
        <p className="secondary-large centered">{message}</p>
      </div>
    </div>
  );
};